(function () {
  var SECTION_SELECTOR = '.oddit-cart-drawer';

  function drawer() {
    return document.querySelector(SECTION_SELECTOR);
  }

  function panel() {
    var section = drawer();
    return section && section.querySelector('.oddit-cart-drawer__panel');
  }

  function openDrawer() {
    var section = drawer();
    if (!section) return;
    section.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var p = panel();
    if (p) p.focus();
  }

  function closeDrawer() {
    var section = drawer();
    if (!section) return;
    section.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function addToCart(variantId, quantity, sellingPlanId) {
    var body = { id: Number(variantId), quantity: quantity || 1 };
    if (sellingPlanId) body.selling_plan = Number(sellingPlanId);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (res.ok) return res.json();
        return res.json().then(function (err) {
          throw new Error(err.description || 'Add to cart failed');
        });
      })
      .then(function (item) {
        return refresh().then(function () { return item; });
      });
  }

  // Set a line to `quantity`, or 0 to remove it. `key` is item.key, which
  // /cart/change.js accepts in place of a line index.
  var linePending = false;

  function changeLine(key, quantity) {
    if (!key || linePending) return Promise.resolve();
    linePending = true;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (res.ok) return res.json();
        return res.json().then(function (err) {
          throw new Error(err.description || 'Cart update failed');
        });
      })
      .then(refresh)
      .catch(function (err) {
        if (window.console) console.error('[oddit-cart-drawer]', err);
        return refresh(); // resync the optimistic quantity with the real cart
      })
      .finally(function () {
        linePending = false;
      });
  }

  function swapLine(key, variantId, quantity, sellingPlanId) {
    if (!key || !variantId || linePending) return Promise.resolve();

    var body = { id: Number(variantId), quantity: quantity || 1 };
    if (sellingPlanId) body.selling_plan = Number(sellingPlanId);

    linePending = true;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (res.ok) return res.json();
        return res.json().then(function (err) {
          throw new Error(err.description || 'Cart update failed');
        });
      })
      .then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      })
      .catch(function (err) {
        if (window.console) console.error('[oddit-cart-drawer]', err);
      })
      .then(function () {
        linePending = false;
        return refresh();
      });
  }

  function changeLinePack(select) {
    var line = select.closest('[data-line-item]');
    if (!line || linePending) return Promise.resolve();

    var key = select.getAttribute('data-line-item-key');
    var variantId = Number(select.value);
    if (!key || !variantId) return Promise.resolve();

    var quantity = parseInt(select.getAttribute('data-line-quantity'), 10) || 1;
    var option = select.options[select.selectedIndex];
    var plans = ((option && option.getAttribute('data-plans')) || '').split(',').filter(Boolean);
    var activePlan = line.getAttribute('data-line-active-plan') || '';
    var plan = plans.indexOf(activePlan) !== -1 ? activePlan : '';

    select.disabled = true;
    return swapLine(key, variantId, quantity, plan);
  }

  // Subscribe (or unsubscribe) every eligible line. Changes go by 1-based line
  // index, not key — change.js mutates the key when it sets a selling plan, so
  // an index is the only stable handle across a batch. Count is unchanged, so
  // indices stay put; one request at a time keeps the cart consistent.
  function setSubscription(enable) {
    var section = drawer();
    if (!section || linePending) return Promise.resolve();

    var lines = Array.prototype.slice.call(section.querySelectorAll('[data-line-item]'));
    var updates = [];
    lines.forEach(function (line, i) {
      var plan = line.getAttribute('data-line-selling-plan');
      var subscribed = line.getAttribute('data-line-subscribed') === 'true';
      if (enable && plan && !subscribed) updates.push({ line: i + 1, plan: Number(plan) });
      else if (!enable && subscribed) updates.push({ line: i + 1, plan: null });
    });
    if (!updates.length) return Promise.resolve();

    linePending = true;
    var seq = Promise.resolve();
    updates.forEach(function (u) {
      seq = seq.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: u.line, selling_plan: u.plan })
        }).then(function (res) {
          if (!res.ok) throw new Error('Subscription update failed');
        });
      });
    });

    return seq
      .catch(function (err) { if (window.console) console.error('[oddit-cart-drawer]', err); })
      .then(function () { linePending = false; return refresh(); });
  }

  // The drawer is server-rendered, so re-fetch it rather than patching line
  // items by hand — the Section Rendering API returns the same markup.
  function refresh() {
    var section = drawer();
    if (!section) return Promise.resolve();

    return fetch('?section_id=' + encodeURIComponent(section.id))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(SECTION_SELECTOR);
        var freshPanel = fresh && fresh.querySelector('.oddit-cart-drawer__panel');
        var current = panel();
        if (current && freshPanel) {
          current.replaceWith(freshPanel);
          // The replaced subtree carries fresh .oddit-reveal nodes (e.g. the
          // empty-state promo CTA) that the interactions observer never saw, so
          // they'd stay stuck at opacity 0. oddit-interactions.js re-observes on
          // shopify:section:load — the same hook Shopify fires for AJAX sections.
          section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        }
      })
      .catch(function () { /* leave the stale panel up rather than blanking it */ });
  }

  // Everything below is bound once at module scope. initSection runs again on
  // shopify:section:load, so document-level listeners must not live inside it.
  function initSection(section) {
    // Panel contents are delegated on the section: refresh() replaces that
    // markup wholesale, and element-bound handlers would not survive it.
    section.addEventListener('click', function (e) {
      if (e.target.closest('.oddit-cart-drawer__overlay, .oddit-cart-drawer__close')) {
        closeDrawer();
        return;
      }

      var toggleSwitch = e.target.closest('.oddit-cart-drawer__toggle-switch');
      if (toggleSwitch) {
        if (linePending) return;
        var willEnable = toggleSwitch.getAttribute('aria-checked') !== 'true';
        toggleSwitch.setAttribute('aria-checked', String(willEnable)); // optimistic; refresh() re-renders it
        setSubscription(willEnable);
        return;
      }

      var removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        changeLine(removeBtn.getAttribute('data-line-item-key'), 0);
        return;
      }

      var qtyBtn = e.target.closest('.oddit-cart-drawer__quantity-btn');
      if (qtyBtn) {
        var qtyWrap = qtyBtn.closest('.oddit-cart-drawer__quantity');
        var valueEl = qtyWrap && qtyWrap.querySelector('.oddit-cart-drawer__quantity-value');
        if (!valueEl) return;
        var current = parseInt(valueEl.textContent, 10) || 1;
        var next = qtyBtn.textContent.trim() === '–' ? Math.max(1, current - 1) : current + 1;
        if (next === current) return;
        valueEl.textContent = next; // optimistic; refresh() re-renders from the cart
        changeLine(qtyBtn.getAttribute('data-line-item-key'), next);
      }
    });

    section.addEventListener('change', function (e) {
      var packSelect = e.target.closest('[data-line-pack-select]');
      if (packSelect) {
        changeLinePack(packSelect);
        return;
      }

      var planSelect = e.target.closest('[data-upsell-plan-select]');
      if (!planSelect) return;

      var card = planSelect.closest('.oddit-cart-drawer__cross-sell');
      if (!card) return;

      var option = planSelect.options[planSelect.selectedIndex];
      var priceEl = card.querySelector('[data-upsell-price]');
      if (priceEl && option) priceEl.textContent = option.getAttribute('data-price');

      var addBtn = card.querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.setAttribute('data-selling-plan', planSelect.value);
    });

    section.addEventListener('keydown', function (e) {
      var toggleSwitch = e.target.closest('.oddit-cart-drawer__toggle-switch');
      if (toggleSwitch && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        toggleSwitch.click();
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    var section = drawer();
    if (e.key === 'Escape' && section && section.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (!toggle) return;
    e.preventDefault();
    openDrawer();
  });

  // Delegated on document: add-to-cart buttons live in other sections
  // (main product, sticky ATC), not just inside the drawer.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;

    // Stops the product form doing a full-page POST to /cart.
    e.preventDefault();

    btn.style.minWidth = btn.getBoundingClientRect().width + 'px';
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    var upgradeKey = btn.getAttribute('data-upgrade-line-key');
    var plan = btn.getAttribute('data-selling-plan');
    var pending = upgradeKey ? swapLine(upgradeKey, variantId, 1, plan) : addToCart(variantId, 1, plan);

    pending
      .then(openDrawer)
      .catch(function (err) {
        if (window.console) console.error('[oddit-cart-drawer]', err);
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.style.minWidth = '';
      });
  });

  window.OdditCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    addToCart: addToCart,
    refresh: refresh,
    toggle: function () {
      var section = drawer();
      if (section) section.classList.contains('is-open') ? closeDrawer() : openDrawer();
    }
  };

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
